import { render, staticRenderFns } from "./PayRunDetail.vue?vue&type=template&id=4b525bb9&scoped=true"
import script from "./PayRunDetail.vue?vue&type=script&lang=js"
export * from "./PayRunDetail.vue?vue&type=script&lang=js"
import style0 from "./PayRunDetail.vue?vue&type=style&index=0&id=4b525bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b525bb9",
  null
  
)

export default component.exports